import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useHttpClient } from 'src/security/hooks/axiosProvider';
import { ITpe } from 'src/pages/accueil/model/types';

export const useTpe = () => {
  const [tpe, setTpe] = useState<ITpe | null>(null);
  const httpClient = useHttpClient();
  const params: any = useParams();

  const fetchTpe = useCallback(async () => {
    if (params?.id) {
      try {
        const response = await httpClient.current?.get(`/api/tpe/${params.id}`);
        setTpe(response?.data);
      } catch (error) {
        console.error("Erreur lors de la récupération du TPE :", error);
      }
    }
  }, [httpClient, params?.id]);

  useEffect(() => {
    fetchTpe();
  }, [fetchTpe]);
  return { tpe, refetchTpe: fetchTpe };
};